import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, NAV } from "@/lib/constants";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#06070d]">
      <div className="pointer-events-none absolute -left-40 top-0 h-80 w-80 glow-red" />
      <div className="pointer-events-none absolute -right-40 bottom-0 h-80 w-80 glow-blue" />
      <div className="wrap relative grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-4">
          <Logo testid="footer-logo-link" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed muted">
            Partner commerciale che collabora con aziende, imprese e attività per valorizzare opportunità e mettere in contatto chi cerca con chi propone.
          </p>
          <p className="mt-4 text-xs muted">PUBBLICELLI non è un'agenzia immobiliare e non è proprietaria delle opportunità pubblicate dai partner.</p>
        </div>
        <div className="md:col-span-2">
          <h2 className="text-sm font-semibold uppercase tracking-wider text-white">Menu</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NAV.map((n) => <li key={n.to}><Link className="muted hover:text-white" to={n.to} data-testid={`footer-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}>{n.label}</Link></li>)}
            <li><Link className="muted hover:text-white" to="/segnala-cosa-cerchi" data-testid="footer-nav-segnala">Segnala cosa cerchi</Link></li>
          </ul>
        </div>
        <address className="not-italic md:col-span-4" data-testid="footer-company-data">
          <h2 className="text-sm font-semibold uppercase tracking-wider text-white">{COMPANY.legal}</h2>
          <ul className="mt-4 space-y-3 text-sm muted">
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-[var(--rosso)]" />{COMPANY.address}</li>
            {COMPANY.phones.map((p) => (
              <li key={p.tel} className="flex gap-3"><Phone size={16} className="mt-0.5 shrink-0 text-[var(--blu)]" /><a href={`tel:${p.tel}`} className="hover:text-white" data-testid={`footer-phone-${p.tel}`}>{p.label}</a></li>
            ))}
            {COMPANY.emails.map((e) => (
              <li key={e} className="flex gap-3"><Mail size={16} className="mt-0.5 shrink-0 text-[var(--blu)]" /><a href={`mailto:${e}`} className="break-all hover:text-white" data-testid={`footer-email-${e.split("@")[0]}`}>{e}</a></li>
            ))}
            <li>P. IVA {COMPANY.vat} · Codice SDI {COMPANY.sdi}</li>
          </ul>
        </address>
        <div className="md:col-span-2">
          <h2 className="text-sm font-semibold uppercase tracking-wider text-white">Informazioni</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/privacy" className="muted hover:text-white" data-testid="footer-privacy-link">Privacy policy</Link></li>
            <li><Link to="/cookie-policy" className="muted hover:text-white" data-testid="footer-cookie-link">Cookie policy</Link></li>
            <li><Link to="/admin/login" className="muted hover:text-white" data-testid="footer-admin-link" rel="nofollow">Area riservata</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="wrap flex flex-col justify-between gap-2 py-6 text-xs muted sm:flex-row">
          <span>© {new Date().getFullYear()} {COMPANY.legal} · P. IVA {COMPANY.vat}</span>
          <span>SITO CASA CE</span>
        </div>
      </div>
    </footer>
  );
}
